<template>
  <bill-card :header="header" :rightBtns="rightBtns">
    <bar-chart
      class="w-100"
      style="height: 200px"
      :columns="columns"
      :rows="rows"
      :label-map="labelMap"
      :setting-options="settingOptions" />
    <slot slot="header-right" name="header-right" />
  </bill-card>
</template>

<script>
import BillCard from '@Bill/components/BillCard'
import BarChart from '@/sections/Charts/Bar'

export default {
  name: 'consumptionTrend',
  components: {
    BillCard,
    BarChart,
  },
  props: {
    header: Object,
    rightBtns: Array,
    columns: Array,
    rows: Array,
    labelMap: {
      type: Object,
      required: true,
    },
    settingOptions: Object,
  },
}
</script>
